import React from 'react';
import type { NumberLineItem } from '../../../../transformers/zod-schemas';
import { toPercent } from '../../../utils/number-line.utils';

export interface HighlightLabelsRowProps {
  highlights: NumberLineItem['highlights'];
  min: number;
  max: number;
}

/** Labels rendered below the highlight bands — never overlaps input widgets. */
export const HighlightLabelsRow: React.FC<HighlightLabelsRowProps> = ({ highlights, min, max }) => {
  if (!highlights?.some(h => h.label)) return null;

  return (
    <div className="number-line-highlight-labels-row" aria-hidden="true">
      {highlights.map(h => {
        if (!h.label) return null;
        const centerPct = (toPercent(h.from, min, max) + toPercent(h.to, min, max)) / 2;
        return (
          <span
            key={`hl-lbl-${h.id}`}
            className="number-line-highlight-label"
            style={{ left: `${centerPct}%` }}
          >
            {h.label}
          </span>
        );
      })}
    </div>
  );
};
